import { render } from "./SwapCard.vue?vue&type=template&id=7bb4652d&scoped=true"
import script from "./SwapCard.vue?vue&type=script&lang=js"
export * from "./SwapCard.vue?vue&type=script&lang=js"

import "./SwapCard.vue?vue&type=style&index=0&id=7bb4652d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb4652d"]])

export default __exports__